import {setLocalStorage} from '@/core/utils/saveDataToLocalStorage.js';

export function checkIfLocalStorageDoesNotContainCurrentState(key, stateData) {
    const storedData = JSON.parse(localStorage.getItem(key)) || [];

    if (storedData.length === 0 && stateData.length > 0) {
        // Если localStorage пустой и в Redux есть данные, заменяем данные в localStorage на данные из Redux
        setLocalStorage(key, stateData);
    }
}